// removed by extract-text-webpack-plugin
module.exports = {"stars":"_3UDldQ33DSP_7kP0qtzhZV","starList":"_3dmUBG_-fi5B8MWjMFGjZa","starBlock":"_1MRnLaRKezpdSaZtCwSESe","bitBackground":"_2Wk3XPgSk59pr4LJLNm6Vs","bgIconLeft":"_3bqhu_s0jUcGKZJqz8uiNI","bgIconRight":"_2uyvxvWrZjzLkg3y6-bWc0"};


//////////////////
// WEBPACK FOOTER
// ./src/sections/Stars/Stars.css
// module id = 191
// module chunks = 0